/* Victory Nutrition — script globale del tema */
(function () {
  'use strict';

  /* ---------- Drawer menu mobile ---------- */
  var drawer = document.querySelector('[data-vn-drawer]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    var closeBtn = drawer.querySelector('[data-vn-menu-close]');
    if (closeBtn && closeBtn.focus) closeBtn.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.querySelectorAll('[data-vn-menu-open]').forEach(function (el) {
    el.addEventListener('click', openDrawer);
  });
  document.querySelectorAll('[data-vn-menu-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
  });

  /* ---------- Conteggio carrello ---------- */
  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-vn-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          if (cart.item_count > 0) { el.removeAttribute('hidden'); }
          else { el.setAttribute('hidden', ''); }
        });
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') > -1) {
      setTimeout(refreshCartCount, 900);
    }
  });

  /* ---------- Link "password dimenticata" ---------- */
  var recoverLink = document.querySelector('[data-vn-recover]');
  if (recoverLink) {
    recoverLink.addEventListener('click', function (e) {
      e.preventDefault();
      var target = document.getElementById('recover');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var input = target.querySelector('input[type="email"]');
        if (input) input.focus({ preventScroll: true });
      }
    });
  }
})();
